import { createAction } from 'redux-actions';

import { rootUiActions, rootUiTypes } from 'companion-app-components/flux/root-ui';

export const DIALOG_TYPE_SYNC_SENTIMENTS_SURVEY = 'DIALOG_TYPE_SYNC_SENTIMENTS_SURVEY';
export const DIALOG_TYPE_SYNC_SENTIMENTS_THANK_YOU = 'DIALOG_TYPE_SYNC_SENTIMENTS_THANK_YOU';

export const triggerSyncSentimentsDialog = createAction(
  rootUiActions.createDialog.toString(),
  () => rootUiTypes.mkRootUiData({
    id: DIALOG_TYPE_SYNC_SENTIMENTS_SURVEY,
    type: DIALOG_TYPE_SYNC_SENTIMENTS_SURVEY,
    allowNesting: false,
  }),
);

export const triggerSyncSentimentsThankYouDialog = createAction(
  rootUiActions.createDialog.toString(),
  () => rootUiTypes.mkRootUiData({
    id: DIALOG_TYPE_SYNC_SENTIMENTS_THANK_YOU,
    type: DIALOG_TYPE_SYNC_SENTIMENTS_THANK_YOU,
    allowNesting: false,
  }),
);
